import { render, staticRenderFns } from "./VmsAppBar.vue?vue&type=template&id=44e336ba&scoped=true"
import script from "./VmsAppBar.vue?vue&type=script&lang=ts"
export * from "./VmsAppBar.vue?vue&type=script&lang=ts"
import style0 from "./VmsAppBar.vue?vue&type=style&index=0&id=44e336ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e336ba",
  null
  
)

export default component.exports